import { Component, computed, inject, input, output, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';

import { TranslatePipe } from '@core/i18n-legacy';
import { TellentMembersDataFacade } from '@core/tellent-logic';
import type { TellentMember } from '@core/tellent-types';
import { resolveMemberFullName } from '@core/tellent-util';
import {
  AvatarComponent,
  BoxComponent,
  ButtonComponent,
  IconComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tl-existing-member-info',
  templateUrl: './existing-member-info.component.html',
  styleUrl: './existing-member-info.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AvatarComponent, ButtonComponent, BoxComponent, IconComponent, TranslatePipe],
})
export class ExistingMemberInfoComponent {
  private readonly membersDataFacade = inject(TellentMembersDataFacade);

  public member = input.required<TellentMember>();
  public canEditAccess = input<boolean>(false);
  public editAccess = output<string>();

  public store = inject(Store);

  public initials = computed(() => {
    const { firstName, lastName, email } = this.member();
    return (firstName && firstName[0] + lastName && lastName[0]) || email[0].toUpperCase();
  });

  public fullName = computed(() => resolveMemberFullName(this.member()));

  public ngOnInit() {
    this.membersDataFacade.fetchOne(this.member()!.guid);
  }
}
